import { StatementScheduledEmail, StatementScheduleStatus } from './model';
import { relativeTimeUntil } from '../../scheduledEmails/utils';

interface StatusChipProps {
  label: string;
  color: 'default' | 'success' | 'warning' | 'error' | 'info';
  tooltip: string;
}

export const scheduleStatusChip = (email: StatementScheduledEmail): StatusChipProps => {
  const status: StatementScheduleStatus = email.schedule_status;

  if (status === 'no_recipients') {
    return { label: 'No recipients', color: 'error', tooltip: 'No email addresses for this account.' };
  }
  if (status === 'auto_paused') {
    return {
      label: 'Automatic paused',
      color: 'warning',
      tooltip: 'Automatic sending is paused for this client. Use Resume automatic to re-enable.',
    };
  }
  if (status === 'auto_skipped') {
    const next = email.next_send_at ? ` Next auto send ${email.next_send_at}.` : '';
    return {
      label: 'Auto skipped — sent manually',
      color: 'info',
      tooltip: `Manual send already went out; the next automatic send for this cycle is skipped.${next}`,
    };
  }
  if (status === 'manual_locked') {
    return {
      label: `Manual locked (${relativeTimeUntil(email.manual_send_locked_until)})`,
      color: 'warning',
      tooltip: 'Manual send was used recently. Available again after a short cooldown.',
    };
  }
  const next = email.next_send_at ? ` Next auto send ${email.next_send_at}.` : '';
  return { label: 'Ready', color: 'success', tooltip: `This client is on the automatic schedule.${next}` };
};

// Withhold attachments when attachments are enabled for this email but at least one debit invoice
// lacks a matched PDF (mirrors the backend all-or-nothing rule). Off when attach_invoices is false
// (location and/or client gate) or debit_invoice_count == 0.
export const attachmentsWithheld = (email: StatementScheduledEmail): boolean =>
  email.attach_invoices !== false &&
  email.debit_invoice_count > 0 &&
  email.matched_pdf_count < email.debit_invoice_count;

export { relativeTimeUntil } from '../../scheduledEmails/utils';
